import referenceDocumentsServices from '../services/referenceDocumentsServices.js';

export default class ReferenceDocumentsDataModel {

  /*************************************************************
   *
   *  Initialization
   *
   *************************************************************/

  constructor(store, dataModel) {
    this.store = store;
    this.dataModel = dataModel;

    this.fetchReferenceDocuments = this.fetchReferenceDocuments.bind(this);
    this.fetchReferenceDocumentsByGroup = this.fetchReferenceDocumentsByGroup.bind(this);
    this.fetchReferenceDocument = this.fetchReferenceDocument.bind(this);
  }

  get stateTree() {
    return this.store.getState();
  }

  fetchReferenceDocuments(searchString = '', document_type = '', markets = '', dateRange = {}, sortField,
    ascending, callBack, numPerPage, whichPage, all) {
 
    if (this.stateTree.new_companies.currentCompany) {
      let page = all ? null : this.stateTree.referenceDocuments.lastReferenceDocumentsPage ? (this.stateTree.referenceDocuments.lastReferenceDocumentsPage + (whichPage ? whichPage : 1)) : 1;
      let perPage = numPerPage ? numPerPage : (all ? null : Math.floor(window.innerHeight / 64));
      referenceDocumentsServices.getReferenceDocuments(searchString, document_type, markets, dateRange, sortField, ascending,
        page, perPage).then(referenceDocuments => {
          if (referenceDocuments.error) {
            this.dataModel.displayHTTPError('Getting referenceDocuments', referenceDocuments.error, true);
          }
          else {
            this.dataModel.catastrophicError = null;
            this.referenceDocuments = referenceDocuments && referenceDocuments.reference_documents ? {
              referenceDocuments: referenceDocuments.reference_documents,
              lastReferenceDocumentsPage: referenceDocuments.meta.last_page, totalReferenceDocuments: referenceDocuments.meta.total_records,
            } : {
              referenceDocuments: [],
              lastReferenceDocumentsPage: 0, totalReferenceDocuments: 0,
            };
            if (callBack) {
              callBack(referenceDocuments.reference_documents);
            }
          }
        });
    }
  }

  fetchReferenceDocumentsByGroup(group_identifier, callBack) {
    if(!this.stateTree.referenceDocuments || !this.stateTree.referenceDocuments['group_identifier_' + group_identifier]){
      referenceDocumentsServices.getReferenceDocumentsByGroup(group_identifier).then(referenceDocuments => {
        if (referenceDocuments.error) {
          this.dataModel.displayHTTPError('Getting referenceDocumentsByGroup', referenceDocuments.error, true);
        } else {
          this.dataModel.catastrophicError = null;
          if (callBack) {
            callBack(referenceDocuments);
          }
          this.setGroupIdentifier(group_identifier, referenceDocuments);
        }
      });
    }
    else{
      callBack(this.stateTree.referenceDocuments['group_identifier_' + group_identifier].groupedReferenceDocuments);
    }
  }

  fetchReferenceDocument(id, callBack) {
    referenceDocumentsServices.getReferenceDocument(id).then(referenceDocument => {
      this.referenceDocument = referenceDocument;
      if (callBack) {
        callBack(!referenceDocument.error ? referenceDocument : null);
      }
    });
  }

  createReferenceDocument(referenceDocument) {
    const callBack = referenceDocument.callBack;
    referenceDocumentsServices.createReferenceDocument(referenceDocument.create).then(newReferenceDocument => {
      if (newReferenceDocument.error) {
        if(newReferenceDocument.error.response.status == 422 && newReferenceDocument.error.response.data.code){
          callBack(newReferenceDocument);
          this.dataModel.systemPopupMessage = { caption: 'ERROR', message: 'The Reference Document code ' + referenceDocument.create.code + ' cannot be used. It already exists.' };
          this.dataModel.displayInfoErrorMessage('Document upload unsuccessful', 4000, 2);
        }
        else if(newReferenceDocument.error.response.status == 418){
          this.dataModel.showGlobalModal('SYSTEM_POPUP', {
            message: 'The Reference Document ' + referenceDocument.create.name + ' cannot be used. It already exists.',
            captionText: 'ERROR',
            height: 184,
            width: 300,
            okButtonText: 'OK',
            oneButton: true,
          });
          callBack(newReferenceDocument);   
        }
        else{
          this.dataModel.displayHTTPError('Creating a Reference Document ', newReferenceDocument.error);
          callBack(newReferenceDocument);          
        }
      } 
      else {
        this.fetchReferenceDocuments('', '', '', {}, 'created_at',
          false, callBack, null, null);
        if(callBack){
          callBack(newReferenceDocument);
        }
        this.dataModel.catastrophicError = null;

      }
    });
  }
  updateReferenceDocument(referenceDocument) {
    const callBack = referenceDocument.callBack;
    referenceDocumentsServices.updateReferenceDocument(referenceDocument.update).then(newReferenceDocument => {
      if(newReferenceDocument.error){
        this.dataModel.displayHTTPError('Updating a Reference Document ', newReferenceDocument.error);
        callBack(null);
      }
      else{
        callBack(newReferenceDocument);
        this.getReferenceDocument(newReferenceDocument.id);
        this.dataModel.catastrophicError = null;         
      }
    });
  }
  
  deleteReferenceDocument(referenceDocument){
    const callBack = referenceDocument.callBack ? referenceDocument.callBack : null;
    referenceDocumentsServices.deleteReferenceDocument(referenceDocument.delete).then(deletionMessage => {
      if (deletionMessage.error) {
        this.dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'The ReferenceDocument ' + referenceDocument.delete.code + ' | ' + referenceDocument.delete.name + ' cannot be deleted because it is in use.' ,
          captionText: 'ERROR',
          height: 184,
          width: 300,
          okButtonText: 'OK',
          oneButton: true,
        });
      }
      else {
        const referenceDocuments = this.stateTree.referenceDocuments.referenceDocuments.filter(m => {
          return m.id != referenceDocument.delete.id;
        });
        this.dataModel.displayInfoErrorMessage('The ReferenceDocument has been successfully deleted.', 4000, 1);
        this.referenceDocuments = referenceDocuments;
        if(callBack){
          callBack(referenceDocuments);
        }
      }
    });
  }

  mergeReferenceDocuments(existingDocuments, newDocuments, shouldPrepend) {
    const existingDocsByGroup = new Map();
    existingDocuments.forEach(doc => existingDocsByGroup.set(doc.group_identifier, doc));
    // make shallow copy of existing docs to avoid mutating state tree vars
    const mergedList = Object.assign([], existingDocuments);
    // Ensure this is a boolean. if true, prepend new docs to beginning of 
    // list (in case of upload), else append to end (i.e. scroll).
    shouldPrepend = shouldPrepend == true ? shouldPrepend : false;
    
    for (let newDoc of newDocuments) {
      let existing = existingDocsByGroup.get(newDoc.group_identifier);
      // TODO: perhaps using created_at below would be better (instead of id)?
      if (!existing || existing.id < newDoc.id) {
        if (existing) {
          if (!shouldPrepend) {
            // replace existing with new
            mergedList.splice(mergedList.indexOf(existing), 1, newDoc);
            continue;
          } else {
            mergedList.splice(mergedList.indexOf(existing), 1);
          }
        }
        if (shouldPrepend) {
          mergedList.unshift(newDoc);
        }
        else {
          mergedList.push(newDoc);
        }
      }
    }
    return mergedList;
  }

  set referenceDocuments(referenceDocuments) {
    if (referenceDocuments && referenceDocuments.clear) {
      this.stateTree.referenceDocuments.referenceDocuments = null;
      this.stateTree.referenceDocuments.lastReferenceDocumentsPage = 0;
      this.stateTree.referenceDocuments.totalReferenceDocuments = 0;
    } else {
      let newReferenceDocuments = [];
      if (referenceDocuments && referenceDocuments.referenceDocuments) {
        if (this.stateTree.referenceDocuments && this.stateTree.referenceDocuments.referenceDocuments) {
          newReferenceDocuments = this.mergeReferenceDocuments(this.stateTree.referenceDocuments.referenceDocuments, referenceDocuments.referenceDocuments, referenceDocuments.shouldPrepend);
        } else {
          newReferenceDocuments = referenceDocuments.referenceDocuments;
        }
      } else {
        newReferenceDocuments = referenceDocuments;
      }
      if (referenceDocuments && newReferenceDocuments) {
        this.store.dispatch({
          type: 'SET_REFERENCE_DOCUMENTS',
          referenceDocuments: newReferenceDocuments,
          lastReferenceDocumentsPage: referenceDocuments && referenceDocuments.lastReferenceDocumentsPage ? referenceDocuments.lastReferenceDocumentsPage : NaN,
          totalReferenceDocuments: referenceDocuments && referenceDocuments.totalReferenceDocuments ? referenceDocuments.totalReferenceDocuments : NaN,
        });
      } else {
        this.store.dispatch({
          type: 'SET_REFERENCE_DOCUMENTS',
          referenceDocuments: null,
          lastReferenceDocumentsPage: 0,
        });
      }
    }
  }
  
  get referenceDocuments() {
    if (!this.stateTree.referenceDocuments.referenceDocuments) {
      this.fetchReferenceDocuments('', '', '', {}, 'created_at',
        false, null, null, null);
      return null;
    }
    else {
      return this.stateTree.referenceDocuments.referenceDocuments;
    }
  }

  getGroupIdentifier(id, callBack){
    if(!this.stateTree.referenceDocuments || !this.stateTree.referenceDocuments['group_identifier_' + id]) {
      referenceDocumentsServices.getReferenceDocumentsByGroup(id).then(referenceDocuments => {
        this.setGroupIdentifier(id, referenceDocuments);
        if(callBack){
          callBack(!referenceDocuments.error ? referenceDocuments : null);
        }
      });
      return null;
    } else {
      if(callBack){
        callBack(this.stateTree.referenceDocuments['group_identifier_' + id].groupedReferenceDocuments);
      }
      return this.stateTree.referenceDocuments['group_identifier_' + id].groupedReferenceDocuments;
    }
  }

  setGroupIdentifier(id, referenceDocuments){
    this.store.dispatch({
      type: 'SET_REFERENCE_DOCUMENTS_GROUP',
      id: id,
      referenceDocuments: referenceDocuments,
    });
  }

  getReferenceDocument(id, callBack) {
    if (!this.stateTree.referenceDocuments || !this.stateTree.referenceDocuments.referenceDocuments || !this.stateTree.referenceDocuments.referenceDocuments[id]) {
      this.dataModel.referenceDocumentsDAO.getReferenceDocument(id, { recordDescriptor: { referenceDocument: { user: {} } } }).then(referenceDocument => {
        this.referenceDocument = referenceDocument;
        if (callBack) {
          callBack(!referenceDocument.error ? referenceDocument : null);
        }
      });
      return null;
    } else {
      if (callBack) {
        callBack(this.stateTree.referenceDocuments.referenceDocuments[id]);
      }
      return this.stateTree.referenceDocuments.referenceDocuments[id];
    }
  }

  set referenceDocument(referenceDocument) {
    if (referenceDocument.create) {
      this.createReferenceDocument(referenceDocument);
    } else if(referenceDocument.update){
      this.updateReferenceDocument(referenceDocument);
    } else if (referenceDocument.delete) {
      this.deleteReferenceDocument(referenceDocument);
    } else {
      this.store.dispatch({
        type: 'SET_REFERENCE_DOCUMENT',
        referenceDocument: referenceDocument,
      });
      let newReferenceDocuments = [];
      if (!this.stateTree.referenceDocuments.referenceDocuments) {
        newReferenceDocuments.push(referenceDocument);
      } else {
        newReferenceDocuments = this.stateTree.referenceDocuments.referenceDocuments.map(m => {
          if (m.id == referenceDocument.id) {
            return referenceDocument;
          } else {
            return m;
          }
        });
      }
      this.referenceDocuments = newReferenceDocuments;
    }
  }

  checkName(name, callBack) {
    referenceDocumentsServices.checkName(name).then(referenceDocument => {
      if (referenceDocument && referenceDocument.id) {
        if (callBack) {
          callBack(true);
        }
      }
      else {
        if (callBack) {
          callBack(false);
        }
      }
    });
  }

  set actionCableReferenceDocument(acReferenceDocument) {
    if (acReferenceDocument.createRDL) {
      let alreadyThere = false;
      let tempReferenceDocuments = this.stateTree.referenceDocuments.referenceDocuments ? this.stateTree.referenceDocuments.referenceDocuments.map(document => {
        if (acReferenceDocument.createRDL.reference_document_id == document.id) {
          alreadyThere = true;
        }
        return document;
      }) : [];
      if (!alreadyThere) {
        
        this.getReferenceDocument(acReferenceDocument.createRDL.reference_document_id, (fetchedDocument) => {   
          if (fetchedDocument) {
            tempReferenceDocuments.splice(0, 0, fetchedDocument);
            this.referenceDocuments = {
              shouldPrepend: true,
              referenceDocuments: tempReferenceDocuments,
            };

            if(this.stateTree.referenceDocuments && this.stateTree.referenceDocuments['group_identifier_' + fetchedDocument.group_identifier]){
              let tempGroupIdentifiers = this.stateTree.referenceDocuments['group_identifier_' + fetchedDocument.group_identifier].groupedReferenceDocuments.map(grd => {
                return grd;
              });
              tempGroupIdentifiers.unshift(fetchedDocument);
              this.setGroupIdentifier(fetchedDocument.group_identifier, tempGroupIdentifiers);
            }
          }
        });
      }
      else {
        this.referenceDocuments = tempReferenceDocuments;
      }
    }
    else if (acReferenceDocument.deleteRDL) {
      let tempReferenceDocuments = this.stateTree.referenceDocuments.referenceDocuments ? this.stateTree.referenceDocuments.referenceDocuments.filter(document => {
        return acReferenceDocument.deleteRDL.reference_document_id != document.id;
      }) : [];  
      this.referenceDocuments = tempReferenceDocuments;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/ReferenceDocumentsDataModel.js